import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  Image
} from '@lockerpm/design';

import authComponents from "./components";

import LoadingIcon from '../../assets/images/icons/loading.svg';

import common from "../../utils/common";

const AuthenticateApp = () => {
  const { t } = useTranslation();
  const { AuthCard } = authComponents;

  const [opened, setOpened] = useState(false)
  const [token, setToken] = useState(null)

  useEffect(() => {
    loginWithToken();
  }, [])

  const loginWithToken = async () => {
    const token = common.getCsLockerToken();
    if (token) {
      setToken(token);
      await common.updateAccessToken(token);
      setTimeout(() => {
        window.location.replace(`lockerapp://auth?token=${token}`)
        setOpened(true)
      }, 5 * 1000)
    } else {
      global.navigate(global.keys.LOGIN)
    }
  }

  return (
    <div
      className="auth-page"
    >
      <AuthCard
        className="w-full"
        paddingTop={192}
      >
        <>
          <div className="text-center">
            <p className="font-semibold text-[24px]">
              {t('authenticate_app.title')}
            </p>
            <p className="mt-2 text-black-600">
              {t('authenticate_app.note')}
            </p>
            {
              !opened && <div className="text-center mt-3">
                <Image
                  className="animate-spin"
                  src={LoadingIcon}
                  preview={false}
                  width={24}
                  height={24}
                />
              </div>
            }
            
            <div className="text-center mt-3">
              <a
                className="text-primary underline hover:text-primary hover:underline"
                href={`lockerapp://auth?token=${token}`}
                onClick={() => setOpened(true)}
              >
                {t('authenticate_app.action')}
              </a>
            </div>
          </div>
        </>
      </AuthCard>
    </div>
  );
}

export default AuthenticateApp;